import { createFileRoute, redirect } from "@tanstack/react-router";

// Patrols has been merged into Guard Tours. Any deep link to /patrols is
// redirected to the unified Guard Tours screen so URLs, bookmarks, and
// existing in-app links keep working without exposing the old route.
export const Route = createFileRoute("/_authenticated/patrols/")({
  beforeLoad: () => {
    throw redirect({ to: "/guard-tours", replace: true });
  },
  component: () => null,
});
